import React from "react";
import { IMG } from "@/lib/assets";

const steps = [
  {
    n: "01",
    title: "Discovery Call",
    desc: "We learn how your business runs and find where AI can save you the most time.",
    photo: null,
  },
  {
    n: "02",
    title: "Strategy & Design",
    desc: "We plan the right AI tools to fit the systems you already use.",
    photo: IMG.code,
    photoAlt: "Close-up of code on a monitor — architecting the system",
  },
  {
    n: "03",
    title: "Build",
    desc: "We build, test, and launch it, then train your team. No tech headaches.",
    photo: null,
  },
  {
    n: "04",
    title: "Maintain & Evolve",
    desc: "We keep it running smoothly and add more as your business grows.",
    photo: null,
  },
];

export default function Process() {
  return (
    <section id="process" className="relative py-12 sm:py-16">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="mb-6">
          <span className="num-tile">How It Works</span>
        </div>

        <div className="relative">
          {/* vertical timeline line on lg */}
          <div className="hidden lg:block absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-px bg-gradient-to-b from-transparent via-[var(--line)] to-transparent" />

          <ol className="space-y-3">
            {steps.map((s, i) => (
              <li
                key={i}
                data-testid={`process-step-${i}`}
                className="lift group relative bg-white border border-[var(--line)] rounded-2xl px-6 py-5 sm:px-8 sm:py-6 grid sm:grid-cols-12 gap-3 sm:gap-8 items-center overflow-hidden"
              >
                {/* Optional environmental photo (used on step 02) */}
                {s.photo && (
                  <div
                    aria-hidden="true"
                    className="absolute inset-0 pointer-events-none"
                  >
                    <img
                      src={s.photo}
                      alt=""
                      loading="lazy"
                      className="w-full h-full object-cover opacity-[0.13] mix-blend-multiply"
                      style={{ filter: "saturate(0.9)" }}
                    />
                    <div
                      className="absolute inset-0"
                      style={{
                        background:
                          "linear-gradient(90deg, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.55) 55%, transparent 100%)",
                      }}
                    />
                  </div>
                )}

                <div className="relative sm:col-span-2 flex items-center gap-4">
                  <span className="font-serif text-[34px] sm:text-[42px] text-[var(--blue)] leading-none">
                    {s.n}
                  </span>
                  <span className="hidden sm:block w-12 h-px bg-[var(--line)] group-hover:bg-[var(--blue)] transition-colors" />
                </div>
                <div className="relative sm:col-span-10">
                  <h3 className="font-serif text-[22px] sm:text-[24px] text-[var(--ink)] leading-tight mb-1.5">
                    {s.title}
                  </h3>
                  <p className="text-[15px] leading-[1.65] text-[var(--ink-muted)] max-w-[640px]">
                    {s.desc}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
